import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfEspecie } from '../../database/index';

import api from '../../services/api';
import { useAuth } from "src/contexts/auth";

export const useFormCreateEspecie = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [especieResponse, setEspecieResponse] = useState<AxiosResponse | null>(null);
  const [especieEditedResponse, setEspecieEditedResponse] = useState<AxiosResponse | null>(null);
  
  const history = useHistory();
  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO: Yup.string().required('* Campo obrigatório'),
  });

  const saveEspecie = async (Especie: ModelOfEspecie) => {
    setLoading(true);

    const newEspecie: ModelOfEspecie = {
      ...Especie,
      ORGAO: userAgencyId,
    }

    if (!!especieResponse) {
      api.put(`especies/${especieResponse.data.ID}`, newEspecie)
        .then((response) => {
          formik.resetForm();
          setEspecieEditedResponse(response);
          setEspecieResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A espécie foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
    api.post('especies', newEspecie)
      .then((response) => {
        if (window.location.href === '/EspecieForm') history.push('/listEspecies')
        setLoading(false);
        setEspecieResponse(response)
        toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Espécie de veículo cadastrado com sucesso!', life: 5000 });
      }).catch((err) => {
        console.log(err);
        setLoading(false);
        toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
      });
    }
  }

  const formik = useFormik<ModelOfEspecie>({
    initialValues: {
      ORGAO: '',
      DESCRICAO: ''
    },
    onSubmit: async values => await saveEspecie(values),
    validationSchema
  });

  return {
    getEspecieFormController: {
      formik,
      loading,
      toast,
      especieResponse,
      especieEditedResponse
    },
    handleEspecieFormController: {
      setEspecieResponse,
      setEspecieEditedResponse
    }
  };
};
